module.exports = __webpack_public_path__ + "static/media/stafford_railway.833489ab.png";